// "use client";

// import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
// import { Provider } from "react-redux";
// import { useState, type ReactNode } from "react";
// import { HotelOnboardingProvider } from "@/context/hotel-onboarding";
// import { AuthProvider } from "@/context/auth-context";
// import { store } from "@/redux/store";

// export default function Providers({ children }: { children: ReactNode }) {
//   const [qc] = useState(() => new QueryClient());

//   return (
//     <Provider store={store}>
//       <AuthProvider>
//         <QueryClientProvider client={qc}>
//           <HotelOnboardingProvider>{children}</HotelOnboardingProvider>
//         </QueryClientProvider>
//       </AuthProvider>
//     </Provider>
//   );
// }

"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Provider } from "react-redux";
import {
  useState,
  useEffect,
  createContext,
  useContext,
  type ReactNode,
} from "react";
import { HotelOnboardingProvider } from "@/context/hotel-onboarding";
import { AuthProvider } from "@/context/auth-context";
import { store } from "@/redux/store";

// ─── Theme Context ─────────────────────────────────────────────────────────────
const ThemeContext = createContext<{
  theme: "light" | "dark";
  toggleTheme: () => void;
}>({ theme: "light", toggleTheme: () => {} });

export function useTheme() {
  return useContext(ThemeContext);
}

function ThemeProvider({ children }: { children: ReactNode }) {
  const [theme, setTheme] = useState<"light" | "dark">("light");

  useEffect(() => {
    const saved = localStorage.getItem("theme") as "light" | "dark" | null;
    // Always default to light unless the user has explicitly chosen dark before.
    // We no longer check window.matchMedia("(prefers-color-scheme: dark)"),
    // so the OS/browser theme preference is ignored.
    const initial = saved ?? "light";
    setTheme(initial);
    document.documentElement.classList.toggle("dark", initial === "dark");
  }, []);

  const toggleTheme = () => {
    const next = theme === "light" ? "dark" : "light";
    setTheme(next);
    localStorage.setItem("theme", next);
    document.documentElement.classList.toggle("dark", next === "dark");
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export default function Providers({ children }: { children: ReactNode }) {
  const [qc] = useState(() => new QueryClient());

  return (
    <Provider store={store}>
      <ThemeProvider>
        <AuthProvider>
          <QueryClientProvider client={qc}>
            <HotelOnboardingProvider>{children}</HotelOnboardingProvider>
          </QueryClientProvider>
        </AuthProvider>
      </ThemeProvider>
    </Provider>
  );
}
